import { render, staticRenderFns } from "./FormAdicionarEmpresaRelacao.vue?vue&type=template&id=cf41331c"
import script from "./FormAdicionarEmpresaRelacao.vue?vue&type=script&lang=js"
export * from "./FormAdicionarEmpresaRelacao.vue?vue&type=script&lang=js"
import style0 from "./FormAdicionarEmpresaRelacao.vue?vue&type=style&index=0&id=cf41331c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports